const el = document.createElement('div');

export function escapeHtml(str) {
  el.textContent = str ?? '';
  return el.innerHTML;
}
